exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/home-page/home-page.css
// module id = Onuz
// module chunks = 0